/**
 * Обратная связь тестировщиков: ошибка, идея, другое — и причина, по
 * которой ученик пока не выбрал платный тариф (`PLAN_REASON`).
 */

import { z } from 'zod';

export const FEEDBACK_KINDS = ['BUG', 'IDEA', 'OTHER', 'PLAN_REASON'] as const;
export type FeedbackKind = (typeof FEEDBACK_KINDS)[number];

/** Сообщение из приложения. `screen` — путь экрана, с которого писали. */
export const FeedbackSchema = z.object({
  kind: z.enum(FEEDBACK_KINDS),
  message: z.string().trim().min(3).max(2000),
  screen: z.string().trim().max(200).optional(),
});
export type FeedbackInput = z.infer<typeof FeedbackSchema>;
